angular.
module("dx.webapp.examParts", [
	"dx.ui.dataTypes.grading",

	"dx.ui.components.localize",
]);
